module.exports = __webpack_public_path__ + "static/img/logowhite.b0a48e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logowhite.png
// module id = +CtD
// module chunks = 1